exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".root---2pwHC{height:5rem;background-color:#add8e6;color:#000;display:flex;justify-content:center;align-items:center}.divider---1gWgm{margin:0 .5rem}.eq---10-5B input{display:none}.eq---10-5B label{padding:.2rem .5rem;background-color:#fff;margin-left:2rem;border-radius:.5rem;border:.1rem solid #000;display:inline-block;width:16rem;text-align:center}", ""]);

// Exports
exports.locals = {
	"root": "root---2pwHC",
	"divider": "divider---1gWgm",
	"eq": "eq---10-5B"
};